import React,{useState, useEffect} from 'react';
import { Container} from "reactstrap";
import { Utilities, Enums } from "@utils";
import { IFollowupBy } from "@interfaces/screens/followupBy.interface";
import ByCountryPresenter from "@presenters/screens/followup-byCountry.presenter";
import { MasterDataGrid } from "@/components/";
import { useParams } from "react-router-dom";
import styles from './index.module.scss';
import Buttons from '../buttons';
import Overlap from './overlap';

interface params {
    screen: string;
}

const FollowupByCountry: React.FC<any> = () => {
    const [dataColumns, setDataColumns] = useState(null)
    const [overData, setOverData] = useState({overlap: [], columns: []})
    const [benDupData, setBenDupData] = useState({beneficiariesDup: [], benColumns: []})
    const [benData, setBenData] = useState({beneficiaries: [], benColumns: []})
    const [countryData, setCountryData] = useState(null)
    const [hasInfo, setHasInfo] = useState(null)
    const [auxScreen, setAuxScreen] = useState(null);

    const params: params = useParams();

    const view: IFollowupBy = {
        state: {
            overData,
            benData,
            dataColumns,
            countryData,
            setDataColumns,
            setCountryData
        },
    };

	const presenter = new ByCountryPresenter(view);
    useEffect(() => {
        presenter.inititalize()
        return () => {
            presenter.clear()
        }
    }, [])
   

    useEffect(() => {
        if(presenter.formMasters) presenter.initByCountry()
    }, [presenter.formMasters]);

    useEffect(() => {
        if(!Utilities.isNullObject(hasInfo)){
            presenter.unSetLoading()
        } 
    }, [hasInfo]);

    useEffect(() => {
        if(presenter.infoByCountry && dataColumns && presenter.formMasters){
            let overlap = presenter.getOverlapByCountry(presenter.infoByCountry)
            let columns = presenter.getOverlapColumns()
            let benColumns = presenter.getBeneficiariesByColumns()
            let beneficiariesDup = presenter.getBeneficiariesDupByCountry(presenter.infoByCountry)

            setOverData({overlap, columns})
            setBenDupData({beneficiariesDup, benColumns})
            setHasInfo(!!overlap?.length)
        }
    }, [presenter.infoByCountry, presenter.formMasters, dataColumns]);

    useEffect(() => {
        if(overData.overlap?.length && benDupData.beneficiariesDup?.length){
            let beneficiaries = presenter.getBeneficiariesByCountry(presenter.infoByCountry, benDupData.beneficiariesDup, overData.overlap, benData.beneficiaries)
            let benColumns = presenter.getBeneficiariesByColumns()
            setBenData({beneficiaries, benColumns})
        }
    }, [overData.overlap, benDupData.beneficiariesDup]);

    useEffect(() => {
        if(!!countryData && !!presenter.formMasters){
            let auxValue: boolean = presenter.getTotalPermissions(countryData);
            setAuxScreen(auxValue ? params.screen: Enums.FollowupState.view)
        } 
    }, [countryData, presenter.formMasters]);

    return (        
        <Container fluid >
            {hasInfo ?
                <>
                    {(!!auxScreen) &&
                        <>
                            {countryData &&
                                <Buttons
                                    screen={auxScreen}
                                    save={presenter.saveData} 
                                    step={1}
                                    followupLabels={presenter.followupLabels} 
                                    data={countryData} 
                                    rightTitle={presenter.followupLabels.get('followupByRightTitle')}
                                />
                            }
                            <div className={styles.divDatagrid} >
                                <Overlap screen={auxScreen} overData={overData} beneficiariesDup={benDupData.beneficiariesDup} />
                                <MasterDataGrid 
                                    id={`beneficiaries-by`}
                                    dataSource={benDupData.beneficiariesDup}
                                    columns={benDupData.benColumns}
                                    allowCode={auxScreen}
                                    gridProps={{
                                        width: '80%',
                                        showColumnHeaders: false,
                                        editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
                                        rowAlternationEnabled:false,
                                        showBorders: true,
                                        showColumnLines: true,
                                        onToolbarPreparing: (e:any) => {                                   
                                            e.toolbarOptions.items.unshift({
                                            location: 'before',
                                            template: `<h6 style="color:rgb(240, 53, 0)">${presenter.followupLabels.get('beneficiariesByCountryDup')}</h6>` 
                                            })
                                        },
                                        onContentReady: (data) => {                           
                                            if(data.component !== undefined){
                                                const rows = data.component.getVisibleRows();
                                                if(rows !== undefined && rows !== null){
                                                    rows.forEach((row:any, index:number) => {                                        
                                                        const element = data.component?.getRowElement(index);
                                                        if(element !== undefined){                                
                                                            element[0].childNodes.forEach((child:any) => {  
                                                                child.classList.add(styles.readOnly);
                                                            });
                                                        }
                                                    });
                                                }
                                            }                            
                                        }
                                    }}
                                />
                                <MasterDataGrid 
                                    id={`beneficiaries-by-no-repeat`}
                                    dataSource={benData.beneficiaries}
                                    columns={benData.benColumns}
                                    allowCode={auxScreen}
                                    gridProps={{
                                        width: '80%',
                                        showColumnHeaders: false,
                                        editing:{ mode:"cell", allowUpdating:true, allowAdding: false, allowDeleting: false},
                                        rowAlternationEnabled:false,
                                        showBorders: true,
                                        showColumnLines: true,
                                        onToolbarPreparing: (e:any) => {                                    
                                            e.toolbarOptions.items.unshift({
                                            location: 'before',
                                            template:`<h6 style="color:rgb(240, 53, 0)">${presenter.followupLabels.get('beneficiariesByCountry')}</h6>` 
                                            })
                                        },
                                        onContentReady: (data) => {
                                            if(data.component !== undefined){
                                                const rows = data.component.getVisibleRows();
                                                if(rows !== undefined && rows !== null){
                                                    rows.forEach((row:any, i:number) => {                                        
                                                        const element: any = data.component?.getRowElement(i);
                                                        if(element !== undefined){                                
                                                            if(i <= 1){
                                                                element[0].childNodes.forEach((child:any, j: number) => {  
                                                                    if(j !== 1) child.classList.add(styles.readOnly);
                                                                });
                                                            }else{
                                                                element[0].childNodes.forEach((child:any) => {  
                                                                    child.classList.add(styles.readOnly);
                                                                });
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </>
                    }
                </>
                :
                    (hasInfo === false) ?
                        <div className={styles.divDatagrid} >
                            <h6 style={{color:"red", padding:"0 1rem"}}>{presenter.followupLabels.get('noInformationFollowupBy')}</h6>
                        </div>
                    : <></>
            }
        </Container>
    )
}

export default FollowupByCountry;